// import React from 'react';
import styled, { css } from 'styled-components';
import { DEEP_BORDER_BOX } from 'common';

export default {
  Wrapper: styled.div`
    ${DEEP_BORDER_BOX}
    height: ${({ toolBarPresent }) => toolBarPresent ? 'calc(100vh - (48px + 69px)) !important' : 'calc(100vh - 48px)'};
    outline: none;
  
  .Resizer {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: ${props => props.$theme.resizer.background};
    z-index: 0;
    -moz-background-clip: padding;
    -webkit-background-clip: padding;
    background-clip: padding-box;
    display: ${({ screenType, toggleSplit }) => (screenType === 'temporary' && !toggleSplit) && 'none'};
  }

  .Resizer:hover {
    // these may seem backward, but they work
    ${({ $disableAnimation }) => $disableAnimation && css`
      -webkit-transition: all 2s ease;
      transition: all 2s ease;
    `}
    ${({ $disableAnimation }) => !$disableAnimation && css`
    -webkit-transition: all 0s;
    transition: all 0s;
  `}
  }

  .Resizer.horizontal {
    height: 6px;
    padding-bottom: 2px;
    padding-top: 2px;
    cursor: row-resize;
    width: 100%;
  }

  .Resizer.horizontal:hover {
    background: ${props => props.$theme.resizer.hover.background};
    border: none;
  }

  .Resizer.vertical {
    width: 6px;
    height: 100%;
    padding-left: 2px;
    padding-right: 2px;
    cursor: col-resize;
  }

  .Resizer.vertical:hover {
    background: ${props => props.$theme.resizer.hover.background};
    border: none
  }

  > .SplitPane {
    position: inherit !important;
  & > .Pane1 {
    ${({ screenType, orientation }) => (screenType === 'permanent' && orientation === 'horizontal') && css`
      min-height: 30%;
      max-height: 70%;
      max-width: 100%;
    `}
    ${({ screenType, orientation }) => (screenType === 'permanent' && orientation === 'vertical') && css`
      min-width: 16%;
      max-width: 66.6%;
    `}
    ${({ screenType, orientation, toggleSplit, primary }) => (screenType === 'temporary' && orientation === 'vertical' && toggleSplit && primary === 'right') && css`
      min-width: 16%;
      max-width: 66.6%;
    `}
    ${({ screenType, orientation, toggleSplit, primary }) => (screenType === 'temporary' && orientation === 'vertical' && toggleSplit && primary === 'left') && css`
      min-width: calc(5% - 10px);
    `}
    ${({ screenType, orientation, toggleSplit, primary, $disableAnimation }) => (screenType === 'temporary' && orientation === 'vertical' && !toggleSplit && primary === 'right') && css`
      width: fit-content;
      display: none;
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
    ${({ screenType, orientation, toggleSplit, primary, $disableAnimation }) => (screenType === 'temporary' && orientation === 'vertical' && !toggleSplit && primary === 'left') && css`
      width: 100vw !important;
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
    ${({ screenType, orientation, toggleSplit }) => (screenType === 'temporary' && orientation === 'horizontal' && toggleSplit) && css`
      min-height: 30%;
      max-height: 70%;
    `}
    ${({ screenType, orientation, toggleSplit }) => (screenType === 'temporary' && orientation === 'horizontal' && !toggleSplit) && css`
      height: calc(100vh - (48px + 69px)) !important;
    `}
    ${({ screenType, orientation, animateIn, $disableAnimation }) => (screenType === 'temporary' && (orientation === 'horizontal' || orientation === 'vertical') && animateIn) && css`
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
  }

  & > .Pane2 {
    ${({ screenType, orientation }) => (screenType === 'permanent' && orientation === 'vertical') && css`
      min-width: 16%;
    `}
    ${({ screenType, orientation }) => (screenType === 'permanent' && orientation === 'horizontal') && css`
      min-height: 30%;
    `}
    ${({ screenType, orientation, toggleSplit, primary }) => (screenType === 'temporary' && orientation === 'vertical' && toggleSplit && primary === 'right') && css`
      min-width: calc(5% - 10px);
    `}
    ${({ screenType, orientation, toggleSplit, primary }) => (screenType === 'temporary' && orientation === 'vertical' && toggleSplit && primary === 'left') && css`
      min-width: 16%;
      max-width: 66.6%;
    `}
    ${({ screenType, orientation, toggleSplit, primary, $disableAnimation }) => (screenType === 'temporary' && orientation === 'vertical' && !toggleSplit && primary === 'right') && css`
      width: 100vw !important;
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
    ${({ screenType, orientation, toggleSplit, primary, $disableAnimation }) => (screenType === 'temporary' && orientation === 'vertical' && !toggleSplit && primary === 'left') && css`
      width: fit-content;
      display: none;
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
    ${({ screenType, orientation, toggleSplit }) => (screenType === 'temporary' && orientation === 'horizontal' && toggleSplit) && css`
      min-height: 30%;
    `}
    ${({ screenType, orientation, toggleSplit, $disableAnimation }) => (screenType === 'temporary' && orientation === 'horizontal' && !toggleSplit) && css`
      height: 0%;
      margin-bottom: 69px;
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
    ${({ screenType, orientation, animateIn, $disableAnimation }) => (screenType === 'temporary' && (orientation === 'horizontal' || orientation === 'vertical') && animateIn) && css`
      ${!$disableAnimation && css`
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1);
      `}
    `}
  }
}
  `,
  Pane: styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    pointer-events: ${props => props.isDragging ? 'none' : 'auto'};
  `
};